import type { SupportedLang } from 'app/lang';

export type UserProfileFormType = 'bet' | 'com' | 'kz' | 'kg' | 'tj';

export type UserProfile = {
  formType: UserProfileFormType;
};

export type DecimalsConfig = {
  betSlip?: number;
  deposit?: number;
  withdrawal?: number;
};

export type CurrencyCode = 'RUB' | 'KZT' | 'KGS' | 'TJS' | 'UZS';
export type ClientCountryDTO = 'RUS' | 'KAZ' | 'KGZ' | 'TJK' | 'UZB';
export type CurrencySign = string;

export type Currency = {
  abbr: CurrencyCode;
  symbol: CurrencySign;
};

export type Registration = {
  disabled: boolean;
  module: string;
  reason: string;
  'user-agreement-url': string;
};

export type Region = {
  id: string;
  title: Record<string, string>;
  domain: string;
};

export type CashbackLevel = {
  endExperience: number;
  levelId: number;
  percentRate: number;
  startExperience: number;
};

export type FreshchatConfig = {
  freshchatToken: string;
  freshchatUuid: string;
  freshchatHost: string;
} | null;

export type ConfigLanguages = string[];

export type BaseURL = string;
export type BetPresets = Record<string, number>;

// Перед использованием нового флага его нужно добавить в FEATURE_FLAGS.
// Пример использования: http://localhost:3000/prematch/top-matches?ff=language
export const enum FeatureFlag {
  ALLOW_WHOLE_FOOTER = 'allowWholeFooter',
  ALLOW_TELEGRAM_SIGN = 'allow_telegram_sign',
  ALLOW_BANNERS = 'allowBanners',
  ALLOW_GAMES = 'allowGames',
  ALLOW_PAYMENT = 'allowPayment',
  ALLOW_SUPPORT = 'allowSupport',
  ALLOW_MOBILE_APP_ICONS = 'allowMobileAppIcons',
  ALLOW_KOMYOB_LICENSE = 'allow_komyob_license',
  CHAIN = 'chain',
  EMAIL = 'email',
  BANNERS_PREVIEW = 'banners_preview',
  CASHBACK = 'cashback',
  PROMOTIONS = 'promo',
  COOKIE_CONSENT = 'cookie_consent',
  ANTLR = 'antlr',
  ANTLR_ERRORS = 'antlr_errors',
  LEFT_MENU = 'left_menu',
  LEFT_MENU_UNION_ICONS = 'left_menu_union_icons',
  PAYMENT_FILTERS = 'payment_filters',
  MESSAGE_PACK = 'message_pack',
  MATCH_FILTER = 'match_filter',
  SUBSTRATE = 'substrate',
  FINGERPRINT = 'fingerprint',
  PREMATCH_FILTER = 'prematch_filter',
  ALLOW_TOTAL_AMOUNT = 'allow_total_amount',
  ONE_CLICK_BET = 'one_click_bet',
  TIME_FILTER = 'time_filter',
  QR_TO_INSTRUCTIONS = 'qr_to_instructions',
  VIRTUALIZER = 'virtualizer',
  REDIRECT_IOS_TO_APP_STORE='redirect_ios_to_app_store',
  OPEN_AUTH_MODAL_ON_ADD_BET_WHEN_NOT_AUTHORIZED='open_auth_modal_on_add_bet_when_not_authorized',
  REQUIRE_USERNAME_ON_ADD_BET='require_username_on_add_bet'
}

export const FEATURE_FLAGS = [
  FeatureFlag.ALLOW_WHOLE_FOOTER,
  FeatureFlag.ALLOW_TELEGRAM_SIGN,
  FeatureFlag.ALLOW_BANNERS,
  FeatureFlag.ALLOW_GAMES,
  FeatureFlag.ALLOW_PAYMENT,
  FeatureFlag.ALLOW_SUPPORT,
  FeatureFlag.ALLOW_MOBILE_APP_ICONS,
  FeatureFlag.ALLOW_KOMYOB_LICENSE,
  FeatureFlag.CHAIN,
  FeatureFlag.EMAIL,
  FeatureFlag.BANNERS_PREVIEW,
  FeatureFlag.CASHBACK,
  FeatureFlag.PROMOTIONS,
  FeatureFlag.COOKIE_CONSENT,
  FeatureFlag.ANTLR,
  FeatureFlag.ANTLR_ERRORS,
  FeatureFlag.LEFT_MENU,
  FeatureFlag.LEFT_MENU_UNION_ICONS,
  FeatureFlag.PAYMENT_FILTERS,
  FeatureFlag.MESSAGE_PACK,
  FeatureFlag.MATCH_FILTER,
  FeatureFlag.SUBSTRATE,
  FeatureFlag.FINGERPRINT,
  FeatureFlag.PREMATCH_FILTER,
  FeatureFlag.ALLOW_TOTAL_AMOUNT,
  FeatureFlag.ONE_CLICK_BET,
  FeatureFlag.TIME_FILTER,
  FeatureFlag.QR_TO_INSTRUCTIONS,
  FeatureFlag.VIRTUALIZER,
  FeatureFlag.REDIRECT_IOS_TO_APP_STORE,
  FeatureFlag.OPEN_AUTH_MODAL_ON_ADD_BET_WHEN_NOT_AUTHORIZED,
  FeatureFlag.REQUIRE_USERNAME_ON_ADD_BET,
] as const;

export type FeatureFlagValues = {
  // ToDo Оставил для примера
  // [FeatureFlag.EXP_AUTHENTICATION]: 'none' | 'registration';
};

export type FeatureFlags = typeof FEATURE_FLAGS[number];

export type SiteConfigs = {
  featureFlags?: FeatureFlags[];
  language?: SupportedLang;
  cashbackLevels?: CashbackLevel[];
  baseUrl?: BaseURL;
  currency?: Currency;
  registration?: Registration;
  userProfile?: UserProfile;
  betPresets?: BetPresets;
  oddsKind?: string;
  defaultCountry?: string;
  defaultRegion?: string;
  decimals?: DecimalsConfig;
  multiDomain?: boolean;
  isUsernameHidden?: boolean;
  promptOnStakeCashout?: boolean;
  promptOnStakeCashoutIncrease?: boolean;
  promptOnStakeCashoutDecrease?: boolean;
  regions?: Region[];
  preMatchFilters?: [];
  freshchatConfig: FreshchatConfig;
  supportedLanguages?: ConfigLanguages;
};
